import { OtsSelect, type OtsSelectOption } from '../components/OtsSelect';
import { OtsEntitySelect } from './OtsEntityMultiSelect';
import { OtsFormRow } from '../components/OtsForm';

export type OtsEntityIdentitySelectProps = {
  entityType: string;
  value?: string;
  entityName?: string;
  label?: string;
  entityTypes?: OtsSelectOption[];
  regionId?: string;
  disabled?: boolean;
  size?: 'compact' | 'default';
  options?: OtsSelectOption[];
  error?: string;
  onChange: (id: string | undefined, type: string) => void;
  onNameChange?: (name?: string) => void;
};
const subjects = [
  { value: 'COMPANY', label: 'Company' },
  { value: 'SITE', label: 'Site' },
  { value: 'WELL', label: 'Well' },
];
/** Keeps an entity's type and ID together; changing type clears the previous selection. */
export const OtsEntityIdentitySelect = ({
  entityType,
  value,
  entityName,
  label = 'Subject',
  entityTypes = subjects,
  regionId,
  disabled,
  size,
  options,
  error,
  onChange,
  onNameChange,
}: OtsEntityIdentitySelectProps) => (
  <div>
    <OtsFormRow>
      <OtsSelect
        label={`${label} type`}
        value={entityType}
        disabled={disabled}
        size={size}
        options={entityTypes}
        onChange={(type) => {
          onNameChange?.(undefined);
          onChange(undefined, type ?? entityTypes[0]?.value ?? '');
        }}
      />
      <OtsEntitySelect
        key={entityType}
        entityType={entityType}
        label={label}
        value={value}
        regionId={regionId}
        size={size}
        options={options}
        disabled={
          disabled || !entityTypes.some((option) => option.value === entityType)
        }
        selectedOptions={
          value ? [{ value, label: entityName ?? value }] : undefined
        }
        onChange={(id) => onChange(id, entityType)}
        onEntityChange={(entity) => onNameChange?.(entity?.displayName)}
      />
    </OtsFormRow>
    {error && (
      <p role="alert" className="mt-1 text-xs text-[var(--ots-error)]">
        {label}: {error}
      </p>
    )}
  </div>
);
